<template>
	<div class="areaguidedetail">
		<Loading msg="loading" v-if="!isload" />
		<div class="guide_inner" v-else>
      		<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <div class="guide_inner_up">
                <h1 class="guide_title">{{guide_area_title}}</h1>
       
                <div class="main_point_title">护理要点</div>
                <div class="main_point_tip">根据您的特征，为您制定以下护理要点</div>
                <ul class="main_point_list">
                    <li class="list_item" v-for="(detail_item,detail_idx) in guide_detail_obj[pore_solution_name]" :key="detail_idx" @click="$parent.routerGo('/poreguideareadetaildescription?detail='+detail_item.title+'&detail_index='+detail_idx+'&solution='+pore_solution_name,(actParams = { query: $route.query, pageid: 496 }),{is_access:true,reportEvent_page_id:'496',reportEvent_page_name:'毛孔-护理要点',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'})">{{detail_item.title.includes('毛孔粗大误区') ? '误区' : detail_item.title}}</li>
                    <!-- <li class="list_item" v-for="(detail_item,detail_idx) in guide_detail_obj[pore_solution_name]" :key="detail_idx" @click="(detail_item.detail.other[0].ingredient.length == 0) ? ((show_guide_detail_layer=true),(show_guide_detail_layer_title=detail_item.title),(show_guide_detail_layer_text=detail_item.detail.suggest)) : $parent.routerGo('/poreguideareadetaildescription?detail='+detail_item.title+'&detail_index='+detail_idx+'&solution='+pore_solution_name)">{{detail_item.title}}</li> -->
                    <!-- <li class="list_item">角栓</li>
                    <li class="list_item">防晒</li> -->
                </ul>
                </div>

                <!-- 护肤方案 -->
                <div class="guide_inner_down">
                    <div class="skincare_rec_title">护肤品搭配方案建议</div>
                    <div class="skincare_rec_title_tip">更多单品请参考护理要点</div>
                    <!-- <div class="switch_btn"><span :class="show_rec ? 'now' : ''" @click="show_rec=true;">早</span><span :class="show_rec ? '' : 'now'" @click="show_rec=false;">晚</span></div> -->
                    <!-- 白天列表 -->
                    <!-- <ul class="rec_list day_rec_list" v-if="show_rec">
                        <li class="rec_list_item" v-for="(m_pro,m_idx) in skincare_step[pore_solution_type].morning" :key="m_idx">
                            <div class="list_item_info">
                                <img :src="m_pro.pic" :key="m_pro.pic" class="item_pic" alt="">
                                <div class="item_detail">
                                    <div class="item_head"><div class="head_left" :class="m_pro.point_icon ? 'serum' : ''"><span class="item_name">{{m_pro.name}}</span><strong class="check_oth" @click="show_oth_pro=true;oth_pro_list=m_pro.check_type;oth_pro_list_name=m_pro.check_oth">{{m_pro.check_oth}}</strong></div><ul class="item_tag"><li class="tag" v-show="m_pro.tag">{{m_pro.tag}}</li></ul></div>
                                    <template v-if="m_pro.usage.length > 0">
                                    <div class="item_effect" v-for="(usage_item,usage_idx) in m_pro.usage" :key="usage_idx">{{usage_item}}</div>
                                    </template>
                                    <div class="item_buy" v-if="m_pro.go_mall" @click="m_pro.go_mall && $parent.goMallDetail(m_pro.pro_id);"><span>去购买</span><img src="../assets/images/arrow_right_c.png" alt=""></div>
                                </div>
                            </div>
                        </li>
                       
                    </ul> -->
                    <!-- 晚上列表 -->
                    <!-- <ul class="rec_list night_rec_list" v-if="!show_rec">
                      <li class="rec_list_item" v-for="(n_pro,n_idx) in skincare_step[pore_solution_type].night" :key="n_idx">
                            <div class="list_item_info">
                                <img :src="n_pro.pic" :key="n_pro.pic" class="item_pic" alt="">
                                <div class="item_detail">
                                    <div class="item_head"><div class="head_left" :class="n_pro.point_icon ? 'serum' : ''"><span class="item_name">{{n_pro.name}}</span><strong class="check_oth" @click="show_oth_pro=true;oth_pro_list=n_pro.check_type;oth_pro_list_name=n_pro.check_oth">{{n_pro.check_oth}}</strong></div><ul class="item_tag"><li class="tag" v-show="n_pro.tag">{{n_pro.tag}}</li></ul></div>
                                    <template v-if="n_pro.usage.length > 0">
                                    <div class="item_effect" v-for="(usage_item,usage_idx) in n_pro.usage" :key="usage_idx">{{usage_item}}</div>
                                    </template>
                                    <div class="item_buy" v-if="n_pro.go_mall" @click="m_pro.go_mall && $parent.goMallDetail(m_pro.pro_id);"><span>去购买</span><img src="../assets/images/arrow_right_c.png" alt=""></div>
                                </div>
                            </div>
                        </li>
                       
                    </ul> -->

                    <!-- 推荐护肤方案 合并为一列 -->
                    <div class="skincare_rec_title_list">
                        <ul class="skincare_rec_title_list_ul">
                            <li class="skincare_rec_title_list_li" v-for="(title_item,title_idx) in skincare_step[pore_solution_type]" :key="title_idx">
                                <img :src="title_item.sketch_url" :key="title_item.sketch_url" class="skincare_rec_title_list_li_pic" :class="!current_index && title_item.show_current ? 'now' : (current_index == title_idx) ? 'now' : (!(title_item.usage.length > 0)) ? 'reject' : ''" alt="" @click="(title_item.usage.length>0)&&((current_index=title_idx),($parent.trackLog((actParams = { query: $route.query, pageid:497 }),{is_access:true,reportEvent_page_id:497,reportEvent_page_name:'毛孔-搭配方案',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'})))">
                                <p class="skincare_rec_title_list_li_name">{{title_item.title_name}}{{title_item.use_mark.length > 0 ? ('('+title_item.use_mark+')') : ''}}</p>
                                <span class="skincare_rec_title_list_li_tag" v-show="title_item.tag.length>0">{{title_item.tag}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="skincare_rec_pro_info_outer">
                        <template v-for="(info_item,info_idx) in skincare_step[pore_solution_type]">
                        <div class="skincare_rec_pro_info" :key="info_idx" v-show="(!current_index && info_item.show_current && (!(pore_solution_type == 'type12'))) || ((current_index == info_idx) && (!(pore_solution_type == 'type12')))">
                            <div class="skincare_rec_pro_info_up" v-show="info_item.usage.length>0">
                                <div class="skincare_rec_pro_info_title">{{info_item.title_name}}</div>
                                <template v-if="info_item.usage.length > 0">
                                <p class="skincare_rec_pro_info_usage" v-for="(usage,usage_idx) in info_item.usage" :key="usage_idx">{{usage}}</p>
                                </template>
                                <!-- <p class="skincare_rec_pro_info_usage">可叠涂2-可叠涂2-3次直至皮肤摸着柔软</p> -->
                            </div>
                            <div class="skincare_rec_pro_info_down" v-if="info_item.has_info">
                                <div class="skincare_rec_pro_info_down_inner"  @click="info_item.go_mall && $parent.goMallDetail(info_item.pro_id);">
                                    <img :src="info_item.img_url" :key="info_item.img_url" class="skincare_rec_pro_info_pic" alt="">
                                    <div class="skincare_rec_pro_info_detail">
                                        <div class="skincare_rec_pro_info_detail_name">{{info_item.name}}</div>
                                        <div class="skincare_rec_pro_info_detail_effect">功效:<span v-for="(effect,effect_idx) in info_item.effect" :key="effect_idx">{{effect}}</span></div>
                                        <div class="skincare_rec_pro_info_detail_price" v-html="info_item.price"></div>
                                    </div>
                                    <div class="skincare_rec_pro_info_gomall" v-show="info_item.go_mall"><span>去购买</span><img src="../assets/images/arrow_right_d.svg" alt=""></div>
                                </div>
                                <div class="skincare_rec_pro_info_check_oth" v-show="info_item.check_oth.length > 0"><span @click="(oth_pro_list=info_item.check_type);(oth_pro_list_name=info_item.check_oth);(show_oth_pro=true);($parent.trackLog((actParams = { query: $route.query, pageid:498 }),{is_access:true,reportEvent_page_id:498,reportEvent_page_name:'毛孔-搭配方案-产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'毛孔'}))">{{info_item.check_oth}}</span></div>
                            </div>
                        </div>
                        </template>

                        <!-- 只有特殊护理 -->
                        <div class="skincare_rec_special_care" v-if="pore_solution_type == 'type12'">
                            <div class="skincare_rec_special_care_title">特殊护理</div>
                            <p class="skincare_rec_special_care_text">由于您的毛孔问题较严重，普通护肤品不能达到很好的效果，可以考虑医美项目。(如果有痤疮、皮炎等皮肤问题或皮肤病，一定要等皮肤恢复健康再去做医美)</p>
                            <div class="skincare_rec_special_care_2nd_title">参考医美项目:</div>
                            <p class="skincare_rec_special_care_2nd_text">激光/射频、微针/滚针、果酸治疗</p>
                        </div>
                    </div>

                </div>
    

                <!-- 其他产品列表弹窗 -->
                <transition name="fade">
                    <div class="oth_rec_layer" v-if="show_oth_pro">
                        <div class="layer_inner">
                            <img src="../assets/images/close_btn.svg" class="close_icon" alt="" @click="show_oth_pro =false">
                            <div class="layer_title">{{oth_pro_list_name}}</div>
                            <ul class="layer_pro_list">
                            <li class="layer_pro" v-for="(oth_pro_item,oth_pro_idx) in oth_pro_total[oth_pro_list]" :key="oth_pro_idx" @click="oth_pro_item.go_mall && $parent.goMallDetail(oth_pro_item.pro_id);">
                            <div class="layer_pro_check_btn" v-if="oth_pro_item.go_mall">
                                <span>去购买</span>
                                <img src="../assets/images/arrow_right_d.svg" class="layer_pro_check_icon" alt="" v-if="oth_pro_item.go_mall">
                            </div>
                                <!-- <img src="../assets/images/arrow_right_d.svg" class="layer_pro_check_icon" alt="" v-if="oth_pro_item.go_mall"> -->
                                <img :src="oth_pro_item.pic" class="pro_pic" alt="">
                                <div class="pro_detail">
                                    <div class="pro_name">{{oth_pro_item.name}}</div>
                                    <div class="pro_ing"><span>功效:</span><span class="ing_item" v-for="(effect,e_idx) in oth_pro_item.ing" :key="e_idx">{{effect}}</span></div>
                                    <div class="pro_price" v-html="oth_pro_item.price"></div>
                                </div>
                            </li>
                           
                            </ul>

                        </div>
                    </div>
                </transition>

                <!-- 对应问题详情只有一段产品文字时 -->
                <div class="guide_detail_text_only" v-if="show_guide_detail_layer">
                    <div class="text_only_inner">
                        <span class="text_only_inner_title">{{show_guide_detail_layer_title}}</span>
                        <div class="text_only_inner_text">{{show_guide_detail_layer_text}}</div>
                        <img src="../assets/images/close_btn.svg" alt="" class="text_only_close_btn" @click="show_guide_detail_layer=false;">
                    </div>
                </div>
		
		</div>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
var wx = require("weixin-js-sdk");
export default {
  name: "PoreGuideAreaDetail",
  data() {
    return {
        isload: false,
        in_weapp: false, //是否在小程序
        guide_area_detail_data:null,
        guide_title_obj:{t_solution:[],v_solution:[]},    //tag 对应标题 （T区+脸颊）
        guide_detail_obj:{t_solution:[],v_solution:[]},   //护理详情  (T区+脸颊)
        show_rec:true,  //早晚护肤列表
        show_oth_pro:false,  //对应类型产品
        show_guide_detail_layer:false,  //只展示详情弹窗 奴进行页面跳转
        show_guide_detail_layer_title:"",  //只展示弹窗时 的标题
        show_guide_detail_layer_text:"",   //只展示弹窗时 文字描述
        guide_area_title:"",  //分区护理title
        oth_pro_list:"",  //其他产品列表
        oth_pro_list_name:"",  //其他产品列表名字
        pore_solution_type:"type1",  //搭配方案对应类型 (初始化时判断T区脸颊)
        pore_solution_name:"",  //T区或脸颊v_solution/t_solution
        current_index:null,   //列表对应展示详情
        skincare_step:{  //毛孔护肤列表
            type1:[
                {
                    title_name:"洁面",  //标题名
                    usage:["根据是否化妆选择增加卸妆步骤","洗面奶加水搓出泡沫，轻柔按摩全脸1min","根据面部油腻程度增减使用量"],
                    show_current:true,  //存在使用描述的第一个展示
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:["取适量化妆水轻柔涂抹全脸至吸收","T区可增加使用量"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:["取适量精华乳轻柔涂抹全脸至吸收","T区出油多部位可增加使用量"],
                    has_info:true,  //是否有详细信息
                    name:"净能控油精萃乳",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",   //产品图
                    effect:["控油"],   //功效
                    price:"会员价:&yen;180/30g",
                    tag:"控油",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它控油产品",  //查看其他产品列表标题
                    check_type:"products_oil_control",  //查看其他产品列表标识
                    go_mall:true,  //是否跳转商城
                    pro_id:"19"
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[""],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[""],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],            
            type2:[
                {
                    title_name:"洁面",  //标题名
                    usage:["根据是否化妆选择增加卸妆步骤","洗面奶加水搓出泡沫，轻柔按摩全脸1min","根据面部油腻程度增减使用量"],
                    show_current:true, 
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:["取适量化妆水轻柔涂抹全脸至吸收","T区可增加使用量"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:["取适量精华乳轻柔涂抹全脸至吸收","T区出油多部位可增加使用量"],
                    has_info:true,  //是否有详细信息
                    name:"净能控油精萃乳",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",   //产品图
                    effect:["控油"],   //功效
                    price:"会员价:&yen;180/30g",
                    tag:"控油",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它控油产品",  //查看其他产品列表标题
                    check_type:"products_oil_control",  //查看其他产品列表标识
                    go_mall:true,  //是否跳转商城
                    pro_id:"19"
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:["此款为晚霜，推荐晚上使用，白天可用其它乳霜产品","初次使用时建议每隔2天使用一次","取黄豆大小的用量于指尖轻点于面部","在皮肤微湿状态下轻柔按摩肌肤至吸收，避开眼部区域"],
                    has_info:true,  //是否有详细信息
                    name:"露得清A醇保湿晚霜",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_neutrogena_anti_wrinkle_cream.png",   //产品图
                    effect:["增强皮肤弹性","改善皱纹","保湿"],   //功效
                    price:"参考价格:&yen;139/40g",
                    tag:"抗衰",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它抗衰产品",  //查看其他产品列表标题
                    check_type:"products_aging_delay",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[""],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type3:[
                {
                    title_name:"洁面",  //标题名
                    usage:["根据是否化妆选择增加卸妆步骤","洗面奶加水搓出泡沫，轻柔按摩全脸1min"],
                    show_current:true, 
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"晚",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:["取适量精华于指尖轻点于面部","在皮肤微湿状态下轻柔按摩肌肤至吸收"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:["此款为晚霜，推荐晚上使用，白天可用其它乳霜产品","初次使用时建议每隔2天使用一次","取黄豆大小的用量于指尖轻点于面部","在皮肤微湿状态下轻柔按摩肌肤至吸收，避开眼部区域"],
                    has_info:true,  //是否有详细信息
                    name:"露得清A醇保湿晚霜",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_neutrogena_anti_wrinkle_cream.png",   //产品图
                    effect:["增强皮肤弹性","改善皱纹","保湿"],   //功效
                    price:"参考价格:&yen;139/40g",
                    tag:"抗衰",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它抗衰产品",  //查看其他产品列表标题
                    check_type:"products_aging_delay",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[""],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type4:[
                {
                    title_name:"洁面",  //标题名
                    usage:["根据是否化妆选择增加卸妆步骤","洗面奶加水搓出泡沫，轻柔按摩全脸1min","根据面部油腻程度增减使用量"],
                    show_current:true, 
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:["取适量化妆水轻柔涂抹全脸至吸收","T区可增加使用量"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:["取适量精华乳轻柔涂抹全脸至吸收","T区出油多部位可增加使用量"],
                    has_info:true,  //是否有详细信息
                    name:"净能控油精萃乳",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",   //产品图
                    effect:["控油"],   //功效
                    price:"会员价:&yen;180/30g",
                    tag:"控油",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它控油产品",  //查看其他产品列表标题
                    check_type:"products_oil_control",  //查看其他产品列表标识
                    go_mall:true,  //是否跳转商城
                    pro_id:"19"
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[""],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type5:[
                {
                    title_name:"洁面",  //标题名
                    usage:["根据是否化妆选择增加卸妆步骤","洗面奶加水搓出泡沫，轻柔按摩全脸1min","根据面部油腻程度增减使用量"],
                    show_current:true, 
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:["取适量化妆水轻柔涂抹全脸至吸收","T区可增加使用量"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:["取适量精华乳轻柔涂抹全脸至吸收","T区出油多部位可增加使用量"],
                    has_info:true,  //是否有详细信息
                    name:"净能控油精萃乳",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",   //产品图
                    effect:["控油"],   //功效
                    price:"会员价:&yen;180/30g",
                    tag:"控油",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它控油产品",  //查看其他产品列表标题
                    check_type:"products_oil_control",  //查看其他产品列表标识
                    go_mall:true,  //是否跳转商城
                    pro_id:"19"
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[""],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"角栓处理",  //标题名
                    usage:["每周2~3次，在化妆水之后使用，代替控油精华","涂抹毛孔粗大部位，注意避开皮损部位","不建议叠加烟酰胺、维A产品"],
                    has_info:true,  //是否有详细信息
                    name:"修丽可果酸焕活复颜精华液",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_plug_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_skinceuticals_for_aging_skin.png",   //产品图
                    effect:["改善细纹","抗皱"],   //功效
                    price:"参考价格:&yen;780/30ml",
                    tag:"去角栓",    //功效标识
                    use_mark:"晚",  //早/晚使用
                    check_oth:"去看其它去角栓产品",  //查看其他产品列表标题
                    check_type:"products_plug_remove",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type6:[
                {
                    title_name:"洁面",  //标题名
                    usage:["根据是否化妆选择增加卸妆步骤","洗面奶加水搓出泡沫，轻柔按摩全脸1min","根据面部油腻程度增减使用量"],
                    show_current:true, 
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:["取适量化妆水轻柔涂抹全脸至吸收","T区可增加使用量"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:["取适量精华乳轻柔涂抹全脸至吸收","T区出油多部位可增加使用量"],
                    has_info:true,  //是否有详细信息
                    name:"净能控油精萃乳",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",   //产品图
                    effect:["控油"],   //功效
                    price:"会员价:&yen;180/30g",
                    tag:"控油",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它控油产品",  //查看其他产品列表标题
                    check_type:"products_oil_control",  //查看其他产品列表标识
                    go_mall:true,  //是否跳转商城
                    pro_id:"19"
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:["此款为晚霜，推荐晚上使用，白天可用其它乳霜产品","初次使用时建议每隔2天使用一次","取黄豆大小的用量于指尖轻点于面部","在皮肤微湿状态下轻柔按摩肌肤至吸收，避开眼部区域"],
                    has_info:true,  //是否有详细信息
                    name:"露得清A醇保湿晚霜",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_neutrogena_anti_wrinkle_cream.png",   //产品图
                    effect:["增强皮肤弹性","改善皱纹","保湿"],   //功效
                    price:"参考价格:&yen;139/40g",
                    tag:"抗衰",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它抗衰产品",  //查看其他产品列表标题
                    check_type:"products_aging_delay",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },

                {
                    title_name:"角栓处理",  //标题名
                    usage:["每周2~3次，在化妆水之后使用，代替控油精华","涂抹毛孔粗大部位，注意避开皮损部位","不建议叠加烟酰胺、维A产品"],
                    has_info:true,  //是否有详细信息
                    name:"修丽可果酸焕活复颜精华液",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_plug_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_skinceuticals_for_aging_skin.png",   //产品图
                    effect:["改善细纹","抗皱"],   //功效
                    price:"参考价格:&yen;780/30ml",
                    tag:"去角栓",    //功效标识
                    use_mark:"晚",  //早/晚使用
                    check_oth:"去看其它去角栓产品",  //查看其他产品列表标题
                    check_type:"products_plug_remove",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type7:[
                {
                    title_name:"洁面",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:["取适量化妆水轻柔涂抹全脸至吸收","可叠涂2-3次直至皮肤摸着柔软稍黏腻"],
                    show_current:true, 
                    has_info:true,  //是否有详细信息
                    name:"优能平衡水",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Toner.png",   //产品图
                    effect:["补水","保湿","舒缓"],   //功效
                    price:"会员价:&yen;220/130ml",
                    tag:"补水",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它补水产品",  //查看其他产品列表标题
                    check_type:"products_water_needs",  //查看其他产品列表标识
                    go_mall:true,  //是否跳转商城
                    pro_id:"15"
                },
                {
                    title_name:"精华",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },

                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type8:[
                {
                    title_name:"洁面",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:["取适量化妆水轻柔涂抹全脸至吸收","可叠涂2-3次直至皮肤摸着柔软稍黏腻"],
                    show_current:true, 
                    has_info:true,  //是否有详细信息
                    name:"优能平衡水",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/Toner.png",   //产品图
                    effect:["补水","保湿","舒缓"],   //功效
                    price:"会员价:&yen;220/130ml",
                    tag:"补水",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它补水产品",  //查看其他产品列表标题
                    check_type:"products_water_needs",  //查看其他产品列表标识
                    go_mall:true,  //是否跳转商城
                    pro_id:"15"
                },
                {
                    title_name:"精华",  //标题名
                    usage:["取适量精华于指尖轻点于面部","在皮肤微湿状态下轻柔按摩肌肤至吸收"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:["此款为晚霜，推荐晚上使用，白天可用其它乳霜产品","初次使用时建议每隔2天使用一次","取黄豆大小的用量于指尖轻点于面部","在皮肤微湿状态下轻柔按摩肌肤至吸收，避开眼部区域"],
                    has_info:true,  //是否有详细信息
                    name:"露得清A醇保湿晚霜",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_neutrogena_anti_wrinkle_cream.png",   //产品图
                    effect:["增强皮肤弹性","改善皱纹","保湿"],   //功效
                    price:"参考价格:&yen;139/40g",
                    tag:"抗衰",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它抗衰产品",  //查看其他产品列表标题
                    check_type:"products_aging_delay",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },

                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type9:[
                {
                    title_name:"洁面",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },

                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    show_current:true, 
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"角栓处理",  //标题名
                    usage:["每周2~3次，在化妆水之后使用，代替正在使用的其它精华","涂抹毛孔粗大部位，注意避开皮损部位","不建议叠加烟酰胺、维A产品"],
                    has_info:true,  //是否有详细信息
                    name:"修丽可果酸焕活复颜精华液",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_skinceuticals_for_aging_skin.png",   //产品图
                    effect:["改善细纹","抗皱"],   //功效
                    price:"参考价格:&yen;780/30ml",
                    tag:"去角栓",    //功效标识
                    use_mark:"晚",  //早/晚使用
                    check_oth:"去看其它去角栓产品",  //查看其他产品列表标题
                    check_type:"products_plug_remove",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type10:[
                {
                    title_name:"洁面",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:["此款为晚霜，推荐晚上使用，白天可用其它乳霜产品","初次使用时建议每隔2天使用一次","取黄豆大小的用量于指尖轻点于面部","在皮肤微湿状态下轻柔按摩肌肤至吸收，避开眼部区域"],
                    show_current:true, 
                    has_info:true,  //是否有详细信息
                    name:"露得清A醇保湿晚霜",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_neutrogena_anti_wrinkle_cream.png",   //产品图
                    effect:["增强皮肤弹性","改善皱纹","保湿"],   //功效
                    price:"参考价格:&yen;139/40g",
                    tag:"抗衰",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它抗衰产品",  //查看其他产品列表标题
                    check_type:"products_aging_delay",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },

                {
                    title_name:"防晒",  //标题名
                    usage:["外出前15分钟使用防晒产品","使用约一枚硬币大小的防晒霜","脖子、耳后也要记得涂抹防晒"],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"早",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"角栓处理",  //标题名
                    usage:["每周2~3次，在化妆水之后使用，代替正在使用的其它精华","涂抹毛孔粗大部位，注意避开皮损部位","不建议叠加烟酰胺、维A产品"],
                    has_info:true,  //是否有详细信息
                    name:"修丽可果酸焕活复颜精华液",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_skinceuticals_for_aging_skin.png",   //产品图
                    effect:["改善细纹","抗皱"],   //功效
                    price:"参考价格:&yen;780/30ml",
                    tag:"去角栓",    //功效标识
                    use_mark:"晚",  //早/晚使用
                    check_oth:"去看其它去角栓产品",  //查看其他产品列表标题
                    check_type:"products_plug_remove",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type11:[
                {
                    title_name:"洁面",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    show_current:true, 
                    usage:["此款为晚霜，推荐晚上使用，白天可用其它乳霜产品","初次使用时建议每隔2天使用一次","取黄豆大小的用量于指尖轻点于面部","在皮肤微湿状态下轻柔按摩肌肤至吸收，避开眼部区域"],
                    has_info:true,  //是否有详细信息
                    name:"露得清A醇保湿晚霜",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_neutrogena_anti_wrinkle_cream.png",   //产品图
                    effect:["增强皮肤弹性","改善皱纹","保湿"],   //功效
                    price:"参考价格:&yen;139/40g",
                    tag:"抗衰",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"去看其它抗衰产品",  //查看其他产品列表标题
                    check_type:"products_aging_delay",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"角栓处理",  //标题名
                    usage:["每周2~3次，在化妆水之后使用，代替正在使用的其它精华","涂抹毛孔粗大部位，注意避开皮损部位","不建议叠加烟酰胺、维A产品"],
                    has_info:true,  //是否有详细信息
                    name:"修丽可果酸焕活复颜精华液",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_suncream_sketch.png",   //线图
                    img_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_skinceuticals_for_aging_skin.png",   //产品图
                    effect:["改善细纹","抗皱"],   //功效
                    price:"参考价格:&yen;780/30ml",
                    tag:"去角栓",    //功效标识
                    use_mark:"晚",  //早/晚使用
                    check_oth:"去看其它去角栓产品",  //查看其他产品列表标题
                    check_type:"products_plug_remove",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
            type12:[   //type12  特殊护理 单独样式
                {
                    title_name:"洁面",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_cleanser_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"水",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_toner_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"精华",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_serum_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                },
                {
                    title_name:"乳液/面霜",  //标题名
                    usage:[],
                    has_info:false,  //是否有详细信息
                    name:"",   //产品详细名
                    sketch_url:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_guide_lotion_sketch.png",   //线图
                    img_url:"",   //产品图
                    effect:[],   //功效
                    price:"",
                    tag:"",    //功效标识
                    use_mark:"",  //早/晚使用
                    check_oth:"",  //查看其他产品列表标题
                    check_type:"",  //查看其他产品列表标识
                    go_mall:false,  //是否跳转商城
                    pro_id:""
                }
            ],
        }, 
        oth_pro_total:{
            products_water_needs:[  //补水其他产品
                {
                    name:"优能平衡水",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/Toner.png",
                    ing:["补水","保湿","舒缓"],  //功效
                    price:"会员价:&yen;220/130ml",
                    go_mall:true,     //是否跳转商城
                    pro_id:"15"
                },
                {
                    name:"香奈儿山茶花保湿面霜",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_chanel_hydra_beauty_cream.png",
                    ing:["保湿"],
                    price:"参考价格:&yen;720/50g",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"雅诗兰黛鲜活亮采红石榴面霜",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_estee_lauder_nutritious_super_pomegranate.png",
                    ing:["提亮肤色","补水","滋润"],
                    price:"参考价格:&yen;590/50ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"黛珂保湿美容液",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_decorte_liposome.png",
                    ing:["保湿"],
                    price:"参考价格:&yen;690/40ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"玉泽皮肤屏障修护保湿水",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_dr_yu_toner.png",
                    ing:["补水","保湿","滋润"],
                    price:"参考价格:&yen;162/200ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"Dr.Ci:Labo VC100化妆水",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_labo_labo_vc100.png",
                    ing:["提亮肤色","补水","保湿","收缩毛孔"],
                    price:"参考价格:&yen;400/150ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"A.H.C B5玻尿酸臻致水合柔肤水",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_hydra_b5_toner.png",
                    ing:["补水","保湿","滋润"],
                    price:"参考价格:&yen;229/120ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"HABA润泽柔肤水",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_haba_g_lotion.png",
                    ing:["抗氧化","补水","保湿","滋润","抗敏感"],
                    price:"参考价格:&yen;389/180ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                }

            ],
            products_oil_control:[  //控油其他产品
                {
                    name:"净能控油精萃乳",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/PIPAR_1.png",
                    ing:["控油"],
                    price:"会员价:&yen;180/30g",
                    go_mall:true,     //是否跳转商城
                    pro_id:"19"
                },
                {
                    name:"理肤泉清痘净肤焕肤精华乳K+",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_la_roche_posay_k_lotion.png",
                    ing:["抗痘"],
                    price:"参考价格:&yen;278/40ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"雅诗兰黛净莹细致化妆水",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_estee_lauder_toner.png",
                    ing:["补水","深层清洁"],
                    price:"参考价格:&yen;250/200ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"ISDIN怡思丁控油净颜平衡日用乳",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_ISDIN_oil_control_lotion.png",
                    ing:["控油"],
                    price:"参考价格:&yen;229/50ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"OLAY光感小白瓶",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_Olay_white_bottle.png",
                    ing:["改善黯沉","提亮肤色","保湿"],
                    price:"参考价格:&yen;280/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"The ordinary 10%烟酰胺精华",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_The_ordinary_10_serum.png",
                    ing:["温和调理肌肤","控油","水油平衡"],
                    price:"参考价格:&yen;85/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"SK-Ⅱ肌因光蕴环采钻白精华露",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_SK_II_diamond_white_serum.png",
                    ing:["提亮肤色","淡化暗斑","淡斑","修护"],
                    price:"参考价格:&yen;2080/60ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"薇诺娜毛孔收缩水",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_winona_toner.png",
                    ing:["收缩毛孔"],
                    price:"参考价格:&yen;188/120ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                }
            ],
            products_aging_delay:[  //抗衰其他产品
                {
                    name:"露得清A醇保湿晚霜",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_neutrogena_anti_wrinkle_cream.png",
                    ing:["增强皮肤弹性","改善皱纹","保湿"],
                    price:"参考价格:&yen;139/40g",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"洛克ROC抗皱精华",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_roc_deep_wrinkle_filler.png",
                    ing:["提亮肤色","损伤修复","抗衰老","保湿"],
                    price:"参考价格:&yen;268/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"The Ordinary 2%维生素A衍生物精华",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_The_Ordinary_2_emulsion.png",
                    ing:["增加皮肤弹性","平抚皱纹","改善细纹"],
                    price:"参考价格:&yen;124/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"Elizabeth Arden 时空焕活夜间多效胶囊精华",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_ElizabethArden_nightserum.png",
                    ing:["改善细纹"],
                    price:"参考价格:&yen;760/28ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"雅诗兰黛 专研紧塑精华素",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_estee_lauder_tight_serum.png",
                    ing:["补水","保湿"],
                    price:"参考价格:&yen;980/50ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"Replenix 白藜芦醇三重精华乳",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_Replenix_bailuchun.png",
                    ing:["提亮肤色","补水","保湿","控油","抗皱"],
                    price:"参考价格:&yen;640/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"欧缇丽 白藜芦醇紧致提升精华液",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_cauddalie_bailuchun.png",
                    ing:["提拉紧致"],
                    price:"参考价格:&yen;550/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"sesderma 白藜芦醇精华",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_SESDERMA6bailuchun.png",
                    ing:["改善黯沉","提亮肤色","活肤滋润","抗氧化"],
                    price:"参考价格:&yen;389/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"Topix Replenix 修复晚霜",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_TopixReplenix_night_serum.png",
                    ing:["保湿","修复"],
                    price:"参考价格:&yen;640/57g",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },

            ],
            products_plug_remove:[  //去角栓其他产品
                {
                    name:"修丽可果酸焕活复颜精华液",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_skinceuticals_for_aging_skin.png",
                    ing:["改善细纹","抗皱"],
                    price:"参考价格:&yen;780/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"博乐达超分子水杨酸柔肤水",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_broda_super_toner.png",
                    ing:["修护","滋养","控油","提亮肤色"],
                    price:"参考价格:&yen;398/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"宝拉珍选2%水杨酸精华液",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_paulas_choice_bha_liquid.png",
                    ing:["调理角质","控油"," 收缩毛孔","抗痘","祛痘"],
                    price:"参考价格:&yen;388/118ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"Martiderm夜间焕肤安瓶",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_Martiderm_night_renew.png",
                    ing:["调理角质","保湿","收缩毛孔","去黑头"],
                    price:"参考价格:&yen;199/10ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"芯丝翠乳糖酸活性乳液",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_neostrata_bionic_lotion.png",
                    ing:["保湿","滋润"],
                    price:"参考价格:&yen;429/100ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"SESDERMA6%经典果酸精华",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_SESDERMA6.png",
                    ing:["改善局部黯沉","改善黯沉","提亮肤色"],
                    price:"参考价格:&yen;389/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"The ordinary 果酸焕肤精华",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_The_ordinary_pink_peeling_solution.png",
                    ing:["提亮肤色","去黑头","去角质"],
                    price:"参考价格:&yen;199/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"Florihana 霍霍巴油",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_Florihana50ml.png",
                    ing:["保湿","舒缓肌肤","柔润肌肤","活肤滋润"],
                    price:"参考价格:&yen;196/50ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"言之有物 霍霍巴油",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_yanzhiyouwujojoba.png",
                    ing:["滋润","深层清洁","清洁毛孔"],
                    price:"参考价格:&yen;136/200ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"HABA 鲨烷精纯美容油",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_HABA.png",
                    ing:["提亮肤色","滋润","淡化暗斑","滋养肌肤"],
                    price:"参考价格:&yen;215/15g",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
                {
                    name:"彼得罗夫 角鲨烷植物精粹纯液",
                    pic:"https://static.inertiabiotech.com/uniskin/reportv3/images/pore_peterrolf_jiaoshawan.png",
                    ing:["补水","保湿","控油"],
                    price:"参考价格:&yen;350/30ml",
                    go_mall:false,     //是否跳转商城
                    pro_id:""
                },
            ]
        },
      imgs: [
        require("../assets/images/1.png"),
        require("../assets/images/2.png"),
        require("../assets/images/3.png"),
        require("../assets/images/4.png")
      ],
      demopic: require("../assets/images/10.png")
    };
  },

  created() {
    console.log("areaguidedetail created", this);
    // alert(this.$route.query.solution);

    this.initAreaDetail();
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initAreaDetail: function() {
      let that = this;
      var local_area_guide_detail = JSON.parse(localStorage.getItem("local_area_guide_detail"));
      if (local_area_guide_detail) {
        afterGuideAreaDetail(local_area_guide_detail);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getPoreSolution"
          )
          .then(json => {
            console.log('guidedetaildata',json);
            afterGuideAreaDetail(json);
            // localStorage.setItem("local_area_guide_detail",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterGuideAreaDetail(guide_area_detail_data) {
        if (guide_area_detail_data.code == 0) {
          that.isload = true;
          that.guide_area_detail_data = guide_area_detail_data.data;
            if(that.$route.query.solution == 't_solution'){
                 that.pore_solution_type = "type"+guide_area_detail_data.data.T_solution;
                 that.guide_area_title = "T区护理";
                 that.pore_solution_name = "t_solution";
            }else if(that.$route.query.solution == 'v_solution'){
                 that.pore_solution_type = "type"+guide_area_detail_data.data.face_solution;
                 that.guide_area_title = "脸颊护理";
                 that.pore_solution_name = "v_solution";
            }

            // alert("poresolution_type"+that.pore_solution_type);
            var guide_total_data_t = guide_area_detail_data.data.T_desc[0];
            var guide_total_data_v = guide_area_detail_data.data.face_desc[0];
            for(let v in guide_total_data_t){
                console.log(v);
                console.log(guide_area_detail_data.data.T_desc[0][v]);
                that.guide_title_obj.t_solution.push(v);
                that.guide_detail_obj.t_solution.push({title:v,detail:guide_total_data_t[v]});
            }
            for(let v in guide_total_data_v){
                console.log(v);
                console.log(guide_area_detail_data.data.face_desc[0][v]);
                that.guide_title_obj.v_solution.push(v);
                that.guide_detail_obj.v_solution.push({title:v,detail:guide_total_data_v[v]});
            }
              console.log('guide_title_obj',that.guide_title_obj);
              console.log('guide_detail_obj',that.guide_detail_obj);


        }
      }
    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";

//20191104  护肤搭配早晚合并为一列
//20191104  护肤搭配早晚合并为一列
.skincare_rec_title_list{
    padding-bottom:40/50rem;
    -webkit-overflow-x:scroll;
    overflow-x:scroll;
    &::-webkit-scrollbar{
        display:none;
    }
    .skincare_rec_title_list_ul{
        padding:0 30/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
            &::after{
            content:"";
            display:block;
            width:40/50rem;
            height:1px;
            .flex_0;
        }
        .skincare_rec_title_list_li{
            position:relative;
            .flex_0;
            padding-right:88/50rem;
            text-align:center;
            .skincare_rec_title_list_li_pic{
                width:123/50rem;
                height:123/50rem;
                .border-radius(50%);
                background:#fff;
                &.now{
                    .shadow;
                }
                &.reject{
                    background:transparent;
                }
            }
            .skincare_rec_title_list_li_name{
                padding-top:20/50rem;
                text-align:center;
                font-size:30/50rem;
                line-height:1em;
                color:@font-c-3;
            }
            .skincare_rec_title_list_li_tag{
                position:absolute;
                left:100/50rem;
                top:0;
                padding:8/50rem 13/50rem;
                .border-radius(19/50rem);
                font-size:20/50rem;
                line-height:1em;
                color:@font-c-f;
                background:@font-c-detail;
                white-space:nowrap;
            }
            &::after{
                content:"";
                display:block;
                position:absolute;
                top:50/50rem;
                right:22/50rem;
                width:44/50rem;
                height:28/50rem;
                background:url("../assets/images/rec_arrow_right.svg") no-repeat 0 0;
                background-size:100%;

            }
            &:last-child{
                padding-right:0;
            }
            &:last-child::after{
                display:none;
            }
        }
    }
}
.skincare_rec_pro_info_outer{
    padding:0 30/50rem 105/50rem;
    .skincare_rec_pro_info{
        .border-radius(14/50rem);
        .shadow;
        background:#fff;
        padding:50/50rem 0 65/50rem;
        .skincare_rec_pro_info_up{
            padding:0 0 20/50rem;
            margin:auto 30/50rem;
           
            .skincare_rec_pro_info_title{
                padding-bottom:20/50rem;
                font-size:30/50rem;
                line-height:1em;
                color:@font-c-3;
                font-weight:bold;
            }
            .skincare_rec_pro_info_usage{
                position:relative;
                padding:0 0 4/50rem 22/50rem;
                font-size:24/50rem;
                line-height:36/50rem;
                color:@font-c-6;
                &::before{
                    content:"";
                    display:block;
                    position:absolute;
                    top:8/50rem;
                    left:0;
                    width:10px;
                    height:10px;
                    .border-radius(50%);
                    -webkit-transform:scale(0.5);
                    transform:scale(0.5);
                    background:@font-c-6;
                }
            }
        }
        .skincare_rec_pro_info_down_inner{
            padding-top:10/50rem;
             .border-top-scale;
            position:relative;
            .display_flex;
            .flex-wrap_nowrap;
            .justify-content_flex-start;
            .skincare_rec_pro_info_pic{
                .align-self_center;
                width:163/50rem;
                height:163/50rem;
            }
            .skincare_rec_pro_info_detail{
                padding-top:28/50rem;
                width:421/50rem;
                .skincare_rec_pro_info_detail_name{
                    padding-bottom:23/50rem;
                    font-size:30/50rem;
                    line-height:1em;
                    color:@font-c-3;
                }
                .skincare_rec_pro_info_detail_effect{
                    .display_flex;
                    .flex-wrap_wrap;
                    .justify-content_flex-start;
                    font-size:24/50rem;
                    line-height:36/50rem;
                    color:@font-c-9;
                    span{
                        .flex_0;
                        font-size:24/50rem;
                        line-height:36/50rem;
                        color:@font-c-9;
                        padding-right:12/50rem;
                    }
                }
                .skincare_rec_pro_info_detail_price{
                    padding-top:16/50rem;
                    font-size:24/50rem;
                    line-height:1em;
                    color:@font-c-9;
                }
            }
            .skincare_rec_pro_info_gomall{
                position:absolute;
                right:30/50rem;
                top:50%;
                transform:translateY(-50%);
                .display_flex;
                .flex-wrap_nowrap;
                .justify-content_flex-end;
                span{
                    font-size:24/50rem;
                    white-space:nowrap;
                    line-height:1em;
                    color:@font-c-detail;
                    .align-self_center;
                }
                img{
                    margin-left:10/50rem;
                    width:27/50rem;
                    height:27/50rem;
                    .align-self_center;
                }
            }
        }
        .skincare_rec_pro_info_check_oth{
            .display_flex;
            .flex-wrap_nowrap;
            .justify-content_flex-end;
            padding-right:30/50rem;
            span{
                font-size:24/50rem;
                line-height:1.1em;
                color:@font-c-detail;
                .border-bottom;
                padding-bottom:2px;
            }
        }
    }
    .skincare_rec_special_care{
        padding:15/50rem 0 74/50rem;
        .skincare_rec_special_care_title{
            font-size:30/50rem;
            line-height:1em;
            font-weight:bold;
            color:@font-c-detail;
        }
        .skincare_rec_special_care_text{
            padding:10/50rem 0;
            font-size:24/50rem;
            line-height:34/50rem;
            color:@font-c-3;
        }
        .skincare_rec_special_care_2nd_title{
            font-size:24/50rem;
            line-height:34/50rem;
            color:@font-c-3;
        }
        .skincare_rec_special_care_2nd_text{
            font-size:24/50rem;
            line-height:34/50rem;
            color:@font-c-3;
        }
    }
}
//对应问题相知只有一段文字时
.guide_detail_text_only{
    position:fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background:rgba(0,0,0,0.2);
    .text_only_inner{
        box-sizing:border-box;
        position:absolute;
        top:50%;
        left:50%;
        -webkit-transform:translate(-50%,-50%);
        transform:translate(-50%,-50%);
        .border-radius(15/50rem);
        .shadow;
        background:@font-c-f;
        padding:69/50rem 30/50rem 84/50rem;
        width:596/50rem;
        .text_only_close_btn{
            position:absolute;
            width:30/50rem;
            height:30/50rem;
            right:30/50rem;
            top:30/50rem;
        }
        .text_only_inner_title{
            font-size:34/50rem;
            line-height:1.1em;
            font-weight:bold;
            color:@font-c-detail;
            border-bottom:1px solid @font-c-detail;
        }
        .text_only_inner_text{
            padding-top:23/50rem;
            font-size:26/50rem;
            line-height:30/50rem;
            color:@font-c-6;
        }
    }
}

.guide_inner{
    background:@bg_c_m;
    padding:0 0 169/50rem;
}
.guide_inner_up{
    padding:126/50rem 30/50rem 0;
    background:@font-c-f;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.guide_title{
    padding-bottom:42/50rem;
    font-size:44/50rem;
    font-weight:bold;
    line-height:1em;
    color:@font-c-3;
}

.main_point_title{
    font-size:34/50rem;
    font-weight:bold;
    line-height:1em;
    color:@font-c-3;
}
.main_point_tip{
    padding:20/50rem 0 43/50rem;
    font-size:25/50rem;
    line-height:1em;
    color:@font-c-3;
}
.main_point_list{
    box-sizing:border-box;
    padding-bottom:61/50rem;
    .display_flex;
    .flex-wrap_wrap;
    .justify-content_flex-start;
    .list_item{
        box-sizing:border-box;
        .flex_0;
        margin-right:14/50rem;
        width:208/50rem;
        height:144/50rem;
        .border-radius(15/50rem);
        .shadow;
        font-size:40/50rem;
        font-weight:bold;
        line-height:144/50rem;
        text-align:center;
        color:@font-c-f;
    }
    .list_item:nth-child(1){
        .gradient(to right,#BBF3D3,#81CFCE);
        margin-bottom:16/50rem;
    }
       .list_item:nth-child(2){
        .gradient(to right,#B5DFF1,#99BDF0);
        margin-bottom:16/50rem;
    }
       .list_item:nth-child(3){
        .gradient(to right,#BCC8F3,#8E83D6);
        margin-bottom:16/50rem;
        margin-right:0;
    }
        .list_item:nth-child(4){
        .gradient(to right,#BEB3F4,#A576D6);
    }
        .list_item:nth-child(5){
        .gradient(to right,#ECB4FF,#DB729D);
    }
        .list_item:nth-child(6){
        .gradient(to right,#F7A7C5,#E66C6C);
    }
}
.guide_inner_down{
    padding:59/50rem 0rem 85/50rem;
    .skincare_rec_title{
        padding-left:30/50rem;
        font-size:34/50rem;
        line-height:1em;
        font-weight:bold;
        color:@font-c-3;
    }
    .skincare_rec_title_tip{
        padding:20/50rem 0 30/50rem 30/50rem;
        font-size:24/50rem;
        line-height:1em;
        color:@font-c-9;
    }
    .switch_btn{
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        padding-bottom:38/50rem;
        span{
            box-sizing:border-box;
            position:relative;
            width:114/50rem;
            height:60/50rem;
            line-height:60/50rem;
            font-size:30/50rem;
            color:@font-c-detail;
            text-align:center;
            color:@font-c-detail;
            margin-right:20/50rem;
            .border-radius(35/50rem);
            background:transparent;
            &::after{
                box-sizing:border-box;
                content:"";
                position:absolute;
                top:0;
                left:0;
                width:200%;
                height:200%;
                .border-radius(70/50rem);
                border:1px solid @font-c-detail;
                -webkit-transform: scale(0.5,0.5);
                transform: scale(0.5,0.5);
                -webkit-transform-origin: top left;
                transform-origin:top left;
            }
            &.now{
                background:@font-c-detail;
                color:@font-c-f;
            }
        }
    }
}
.rec_list{
    .shadow;
    .border-radius(14/50rem);
    background:@bg_c_l;
    box-sizing:border-box;
    padding:30/50rem 30/50rem 60/50rem 0;
}
.rec_list_item{
    position:relative;
    padding-bottom:100/50rem;
    &::after{
        content:"";
        display:block;
        position:absolute;
        left:70/50rem;
        bottom:23/50rem;
        width:28/50rem;
        height:44/50rem;
        background:url('../assets/images/arrow_down.png') no-repeat 0 0;
        background-size:contain;
    }
}
.rec_list .rec_list_item:last-child{
    padding-bottom:30/50rem;
    &::after{
        display:none;
    }
}
.list_item_info{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .item_pic,.item_detail{
        .align-self_flex-start;
    }
    .item_pic{
        width:163/50rem;
    }
    .item_detail{
        width:490/50rem;
        .item_head{
           .display_flex;
           .flex-wrap_nowrap;
           .justify-content_flex-justify;
           margin-bottom: 37/50rem;
           .head_left{
               position:relative;
               .display_flex;
               .flex-wrap_nowrap;
               .justify-content_flex-start; 
               &.serum::before{
                   content:"";
                   display:block;
                   position:absolute;
                   left:-32/50rem;
                   top:50%;
                   width:14px;
                   height:14px;
                   .border-radius(50%);
                   background:#f05956;
                   transform: translateY(-50%) scale(0.5);
               }
               .item_name{
                   white-space:nowrap;
                   font-size:30/50rem;
                   font-weight:bold;
                   line-height:1em;
                   padding-right:20/50rem;
                   .align-self_flex-end;
               }
               .check_oth{
                   white-space:nowrap;
                   font-size:24/50rem;
                   line-height:1em;
                   color:@font-c-detail;
                   border-bottom:1px solid @font-c-detail;
                    .align-self_flex-end;
               }
           }
           .item_tag{
               .display_flex;
               .flex-wrap_nowrap;
               .justify-content_flex-end;
               .tag{
                   white-space:nowrap;
                   .align-self_flex-end;
                   margin-left:20/50rem;
                   padding:8/50rem 19/50rem;
                   box-sizing:border-box;
                   background:#ffe6e3;
                   font-size:24/50rem;
                   line-height:1em;
                   color:@font-c-detail;
                   .border-radius(23/50rem);
               }
           }
        }
        .item_effect{
            position:relative;
            padding-left:33/50rem;
            margin-bottom:8/50rem;
            font-size:24/50rem;
            color:@font-c-6;
            &::before{
                content:"";
                display:block;
                width:10px;
                height:10px;
                background:@font-c-6;
                .border-radius(50%);
                position:absolute;
                left:11/50rem;
                top:50%;
                transform:translateY(-50%) scale(0.5);
            }
        }
        .item_buy{
            .display_flex;
            .flex-wrap_nowrap;
            .justify-content_flex-end;
            padding-top:8/50rem;
            span,img{
                .align-self_center;
            }
            span{
                font-size:24/50rem;
                line-height:1em;
                color:@font-c-detail;
                margin-right:18/50rem;
            }
            img{
                width:14/50rem;
                height:27/50rem;
            }
        }
    }
}
.oth_rec_layer{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.2);
    .layer_inner{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width:690/50rem;
        height:1033/50rem;
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        box-sizing:border-box;
        padding:45/50rem 20/50rem 45/50rem 0;
        .close_icon{
            position:absolute;
            top:52/50rem;
            right:30/50rem;
            width:30/50rem;
            height:30/50rem;
        }
        .layer_title{
            padding:0 0 60/50rem 30/50rem;
            font-size:44/50rem;
            line-height:1em;
            font-weight:bold;
        }
    }
}
.layer_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    position:relative;
    .layer_pro_check_icon{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
        width:27/50rem;
        height:27/50rem;
    }
    .layer_pro_check_btn{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
        width:14/50rem;
        height:27/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            .align-self_center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-detail;
            padding-right:30/50rem;
            white-space:nowrap;
        }
        img{
            .align-self_center;
            width:27/50rem;
            height:27/50rem;
        }
    }
    .pro_pic,.pro_detail{
        .align-self_flex-start;
    }
    .pro_pic{
        width:163/50rem;
    }
    .pro_detail{
        padding:16/50rem 50/50rem 55/50rem 0;
        margin-bottom:29/50rem;
        width:494/50rem;
        border-bottom:1px solid @font-c-detail;
        .pro_name{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-bottom:23/50rem;
        }
        .pro_ing{
            .display_flex;
            .justify-content_flex-start;
            span{
                .flex_0;
                font-size:24/50rem;
                line-height:1em;
                color:@font-c-9;
                &.ing_item{
                    padding-right:20/50rem;
                }
            }
            
        }
        .pro_price{
            padding-top:16/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-9;
        }
    }
}
.layer_pro_list{
    height:863/50rem;
    -webkit-overflow-y:scroll;
    overflow-y:scroll;
    box-sizing:border-box;
}
.layer_pro_list .layer_pro:last-child{
    .pro_detail{
        border-bottom:1px solid transparent;
    }
}
</style>
